import { render, staticRenderFns } from "./izin.vue?vue&type=template&id=5b0e3bd3"
import script from "./izin.vue?vue&type=script&lang=js"
export * from "./izin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports